// src/components/Toast.js – Enhanced with glow
import React from 'react';
import { useAuth } from '../context/AuthContext';
import useViewport from '../hooks/useViewport';

const COLORS = {
  success: { border: 'rgba(57,255,20,0.45)',  title: '#39ff14', glow: 'rgba(57,255,20,0.12)'  },
  gold:    { border: 'rgba(255,215,0,0.45)',  title: '#ffd700', glow: 'rgba(255,215,0,0.12)'  },
  error:   { border: 'rgba(255,68,68,0.45)',  title: '#ff6464', glow: 'rgba(255,68,68,0.12)'  },
  info:    { border: 'rgba(0,245,255,0.45)',  title: '#00f5ff', glow: 'rgba(0,245,255,0.12)'  },
};

export default function Toast() {
  const { toast } = useAuth();
  const { isMobile } = useViewport();
  if (!toast) return null;
  const s = COLORS[toast.type] || COLORS.info;
  return (
    <div style={{
      position:'fixed', top:isMobile ? '64px' : '70px', right:isMobile ? '12px' : '20px', left:isMobile ? '12px' : 'auto', zIndex:9998,
      background:'rgba(10,10,15,0.97)', border:`1px solid ${s.border}`,
      borderRadius:'10px', padding:'14px 18px', minWidth:isMobile ? '0' : '260px', maxWidth:isMobile ? 'unset' : '340px',
      boxShadow:`0 4px 28px rgba(0,0,0,0.55), 0 0 24px ${s.glow}`,
      animation:'slideInToast 0.32s cubic-bezier(0.16,1,0.3,1)',
      backdropFilter:'blur(14px)', WebkitBackdropFilter:'blur(14px)',
    }}>
      <style>{`
        @keyframes slideInToast {
          from { transform: translateX(24px) scale(0.96); opacity: 0; }
          to   { transform: translateX(0) scale(1); opacity: 1; }
        }
      `}</style>
      {/* Top glow line */}
      <div style={{ position:'absolute', top:0, left:0, right:0, height:'2px', borderRadius:'10px 10px 0 0',
                    background:`linear-gradient(90deg,transparent,${s.title},transparent)`, opacity:0.7 }} />
      <div style={{ fontWeight:700, fontSize:'15px', color:s.title, marginBottom:'3px',
                    textShadow:`0 0 8px ${s.glow}` }}>{toast.title}</div>
      {toast.body && <div style={{ fontSize:'15px', color:'rgba(255,255,255,0.5)' }}>{toast.body}</div>}
    </div>
  );
}
